import { useEffect, useMemo, useState } from "react";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Settings page components
import FormField from "components/FormField";

import {
  Card,
  Switch,
  Grid,
  Autocomplete,
  prefix,
  Input,
  Chip,
  Icon,
} from "@mui/material";
import IconPicker from "components/IconPicker";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import AutocompleteWithPagination from "components/AutocompleteWithPagination";
import CrudService from "services/cruds-service";
import prepareNewArr from "helper/prepareNewArr";

function MainInfo({
  article,
  changeHandler,
  autoSwitchChangeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
  type,
  projects,
  main,
  page,
  isMain,
  isFieldVisible,
  prefix,
}) {
  const effects = ["fade", "slide", "flip", "cube", "coverflow"];

  const [inputs, setInputs] = useState([
    {
      project: null,
      order: "",
    },
  ]);
  const getData = async (name, page, search) => {
    if (name === "projects") {
      const projectsData = await CrudService.getAllData(
        `items/projects?fields=id,translations.name,translations.languages_code&filter[status][_eq]=published&filter[translations][languages_code][_eq]=ar-SA&filter[all_amount_required][_eq]=false${
          search && `&filter[translations][name][_contains]=${search}`
        }&page=${page}&limit=${CrudService.getLimit()}`,
      );
      return prepareNewArr(projectsData.data);
    } else if (name === "blogs") {
      const blogsData = await CrudService.getAllData(
        `items/article?fields=id,translations.title,translations.languages_code&filter[status][_eq]=published&filter[type][_eq]=b&filter[translations][languages_code][_eq]=ar-SA${
          search && `&filter[translations][title][_contains]=${search}`
        }&page=${page}&limit=${CrudService.getLimit()}`,
      );
      return prepareNewArr(blogsData.data, "title");
    } else if (name === "faq") {
      const faqData = await CrudService.getAllData(
        `items/faq?fields=id,translations.question,translations.languages_code&filter[status][_eq]=published&filter[translations][languages_code][_eq]=ar-SA${
          search && `&filter[translations][question][_contains]=${search}`
        }&page=${page}&limit=${CrudService.getLimit()}`,
      );
      return prepareNewArr(faqData.data, "question");
    } else if (name === "reports") {
      const reportsData = await CrudService.getAllData(
        `items/reports?fields=id,translations.title,translations.languages_code&filter[status][_eq]=published&filter[translations][languages_code][_eq]=ar-SA${
          search && `&filter[translations][title][_contains]=${search}`
        }&page=${page}&limit=${CrudService.getLimit()}`,
      );
      return prepareNewArr(reportsData.data, "title");
    }
    return [];
  };

  const handleAddInput = () => {
    setInputs([
      ...inputs,
      {
        project: null,
        order: "",
      },
    ]);
  };

  useEffect(() => {
    article?.content &&
      article?.content.length > 0 &&
      setInputs(article.content);
  }, [article]);

  const handleChange = (name, index, v) => {
    let onChangeValue = [...inputs];
    onChangeValue[index][name] = v;
    setInputs(onChangeValue);
    autoSwitchChangeHandler("content", onChangeValue);
  };

  const handleDeleteInput = (index) => {
    const newArray = [...inputs];
    newArray.splice(index, 1);
    setInputs(newArray);
    autoSwitchChangeHandler("content", newArray);
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">بيانات النشر</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            lg={
              type === "slider" && isMain
                ? 3
                : type === "identity" && isMain
                ? 6
                : 12
            }
          >
            <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
              <MDBox mt={0.5}>
                <Switch
                  name="isVisible"
                  checked={info?.isVisible || false}
                  onChange={() =>
                    autoSwitchChangeHandler("isVisible", !info?.isVisible)
                  }
                />
              </MDBox>
              <MDBox width="80%" ml={0.5}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  الحالة
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>
          {isFieldVisible(prefix + "iconName", type) && (
            <Grid item xs={12}>
              <Grid item xs={12}>
                <MDBox mb={2}>
                  <MDTypography
                    variant="body2"
                    fontWeight="medium"
                    gutterBottom
                  >
                    أيقونة المشروع
                  </MDTypography>
                  <IconPicker
                    value={main ? info?.data?.iconName : info?.iconName}
                    onChange={(i) => autoSwitchChangeHandler("iconName", i)}
                    label="اختر أيقونة للمشروع"
                    error={errors?.iconName}
                    helperText={errors?.iconName}
                  />
                </MDBox>
              </Grid>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            lg={
              type === "slider" && isMain
                ? 3
                : type === "identity" && isMain
                ? 6
                : 12
            }
          >
            <FormField
              onChange={(e) => {
                autoSwitchChangeHandler(e.target.name, e.target.value);
              }}
              variant="outlined"
              type="number"
              label="الترتيب"
              name="order"
              value={info?.order || 0}
              placeholder="الترتيب"
              error={errors.order}
            />
          </Grid>
          {isFieldVisible(prefix + "speed", type) && (
            <Grid item xs={12} lg={type === "slider" && isMain ? 3 : 12}>
              <FormField
                onChange={(e) => {
                  autoSwitchChangeHandler(e.target.name, e.target.value);
                }}
                variant="outlined"
                type="number"
                label="المدة"
                name="speed"
                value={info?.speed || 0}
                placeholder="المدة"
                error={errors.speed}
              />
            </Grid>
          )}
          {isFieldVisible(prefix + "effect", type) && (
            <Grid item xs={12} lg={type === "slider" && isMain ? 3 : 12}>
              <Autocomplete
                variant="outlined"
                options={effects}
                name="effect"
                renderOption={(props, option) => (
                  <li {...props} key={option}>
                    {option}
                  </li>
                )}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, item) =>
                  option === item || option === item
                }
                renderInput={(params) => (
                  <FormField
                    variant="outlined"
                    {...params}
                    label="التأثير"
                    error={errors.effect}
                  />
                )}
                value={info?.effect || null}
                onChange={(e, v) => autoSwitchChangeHandler("effect", v)}
              />
            </Grid>
          )}
          {(type === "projects_list" ||
            type === "blogs_list" ||
            type === "faq" ||
            type === "reports") && (
            <Grid item xs={12}>
              {inputs.map((item, index) => (
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  key={index}
                  pt={1}
                >
                  <Grid item xs={12} md={inputs.length > 1 ? 6 : 7}>
                    <AutocompleteWithPagination
                      limit={CrudService.getLimit()}
                      name={
                        type === "blogs_list"
                          ? "blogs"
                          : type === "projects_list"
                          ? "projects"
                          : type === "reports"
                          ? "reports"
                          : "faq"
                      }
                      value={item.project}
                      onChange={(v) => handleChange("project", index, v)}
                      getData={getData}
                      label={
                        type === "blogs_list"
                          ? "القصة"
                          : type === "projects_list"
                          ? "المشروعات"
                          : type === "reports"
                          ? "التقارير"
                          : "الأسئلة"
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormField
                      label="الترتيب"
                      placeholder=""
                      name="order"
                      onChange={(event) =>
                        handleChange("order", index, event.target.value)
                      }
                      value={item.order}
                    />
                  </Grid>
                  {inputs.length > 1 && (
                    <Grid item xs={12} md={1}>
                      <MDButton onClick={() => handleDeleteInput(index)}>
                        -
                      </MDButton>
                    </Grid>
                  )}
                  {index === inputs.length - 1 && (
                    <Grid item xs={12} md={1}>
                      <MDButton onClick={() => handleAddInput()}>+</MDButton>
                    </Grid>
                  )}
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </MDBox>
    </Card>
  );
}

export default MainInfo;
